import React from "react";
import {
  FaFacebook,
  FaInstagram,
  FaCalendarAlt,
  FaExternalLinkAlt,
  FaCheckCircle,
  FaArrowRight,
} from "react-icons/fa";
import { motion } from "framer-motion";

const SocialMediaLink = ({ href, icon: Icon, label, hoverClass }) => (
  <motion.a
    whileHover={{ y: -2 }}
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className={`flex items-center gap-3 px-5 py-2.5 rounded-xl font-bold text-xs uppercase tracking-wider transition-all bg-white border border-stone-200 text-stone-600 shadow-sm ${hoverClass}`}
  >
    <Icon className="text-base" />
    <span>{label}</span>
    <FaExternalLinkAlt className="text-[10px] opacity-30" />
  </motion.a>
);

export default function OfertaDnia() {
  return (
    <section id="offerweek" className="relative z-10 py-20 overflow-hidden">
      {/* Tło spójne z Menu */}
      <div className="absolute inset-0 bg-gradient-to-br -z-10" />

      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-12 items-center px-4">
        {/* Lewa strona - Tekst */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center lg:text-left"
        >
          <h2 className="text-4xl sm:text-5xl font-black text-stone-800 leading-[1.1] uppercase tracking-tighter mb-6">
            Najlepsze smaki,
            <br />
            <span className="text-cream-700">Zawsze świeże</span>
          </h2>

          <p className="text-stone-600 text-lg mb-8 max-w-lg mx-auto lg:mx-0 leading-relaxed font-medium">
            Co tydzień nowe menu, zadzwoń do nas już teraz!
            <span className="block mt-2 text-stone-400 font-normal text-base italic">
              Zaskocz swoje kubki smakowe każdego dnia!
            </span>
          </p>

          <div className="flex flex-wrap gap-3 justify-center lg:justify-start">
            <button
              onClick={() =>
                window.open("https://www.facebook.com/AnatomiaSmaku", "_blank")
              }
              className="flex items-center gap-2 px-5 py-3 border border-stone-300 rounded-full
               text-stone-700 font-semibold transition
               hover:text-blue-600 hover:border-blue-200"
            >
              <FaFacebook className="text-xl" />
              Facebook
            </button>

            <button
              onClick={() =>
                window.open(
                  "https://www.instagram.com/anatomia.smaku/",
                  "_blank",
                )
              }
              className="flex items-center gap-2 px-5 py-3 border border-stone-300 rounded-full
               text-stone-700 font-semibold transition
               hover:text-pink-600 hover:border-pink-200"
            >
              <FaInstagram className="text-xl" />
              Instagram
            </button>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
          className="relative"
        >
          <div className="bg-white border border-stone-200 rounded-2xl overflow-hidden shadow-xl">
            {/* Górna belka karty */}
            <div className="bg-stone-800 px-6 py-3 flex justify-between items-center text-white">
              <span className="text-[10px] font-black uppercase tracking-widest">
                Aktualności
              </span>
              <div className="flex gap-1">
                <div className="w-2 h-2 rounded-full bg-cream-500"></div>
                <div className="w-2 h-2 rounded-full bg-stone-600"></div>
              </div>
            </div>

            <div className="p-8 md:p-10">
              <h3 className="text-2xl font-black text-stone-800 mb-6 leading-tight uppercase tracking-tight">
                Sprawdź, co przygotowaliśmy <br className="hidden md:block" />{" "}
                na ten tydzień!
              </h3>

              <ul className="space-y-4 mb-10">
                {[
                  "Codziennie gotujemy z pasją",
                  "Kuchnia pełna uśmiechu",
                  "Świeże składniki",
                ].map((text, i) => (
                  <li
                    key={i}
                    className="flex items-center gap-3 text-stone-600 font-medium"
                  >
                    <FaCheckCircle className="text-cream-600 text-lg shrink-0" />
                    <span>{text}</span>
                  </li>
                ))}
              </ul>

              <motion.a
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                href="https://www.facebook.com/AnatomiaSmaku"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-3 w-full py-4 bg-cream-700 hover:bg-cream-800 text-white rounded-xl font-black uppercase tracking-[0.2em] text-xs transition-all shadow-lg"
              >
                Sprawdź oferte
                <FaArrowRight />
              </motion.a>
            </div>
          </div>

          {/* Element dekoracyjny w tle karty */}
          <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-cream-600/10 rounded-full -z-10 blur-2xl"></div>
        </motion.div>
      </div>
    </section>
  );
}
